/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockInboundDetailResVo
 */
export interface StockInboundDetailResVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    orderCode?: string;
    /**
     * 实际入库的库存批次订单号
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    batchCode?: string;
    /**
     * 来源订单号；原运单退货入库时为原3PL出库订单号
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    sourceOrderCode?: string;
    /**
     * 出入库业务场景编码
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    inOutBizType?: number;
    /**
     * 出入库业务场景名称，如原运单退货入库
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    inOutBizTypeName?: string;
    /**
     * 申请类别编码，见 RequestTypeEnum
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    requestType?: number;
    /**
     * 申请类别名称（按当前语言）
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    requestTypeName?: string;
    /**
     * 入库日期
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    inboundDate?: string;
    /**
     * 数量
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    skuNumber?: number;
    /**
     * 单价(元)
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    skuCost?: number;
    /**
     * 单品重量(KG)
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    wtKg?: number;
    /**
     * 单品规格
     * @type {string}
     * @memberof StockInboundDetailResVo
     */
    packageSpecification?: string;
    /**
     * 单品体积(CBM)
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    singleCbm?: number;
    /**
     * 总体积(CBM)
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    totalCbm?: number;
    /**
     * 能否原包装出库：0 否，1 是
     * @type {number}
     * @memberof StockInboundDetailResVo
     */
    originPackageOutbound?: number;
}

/**
 * Check if a given object implements the StockInboundDetailResVo interface.
 */
export function instanceOfStockInboundDetailResVo(value: object): value is StockInboundDetailResVo {
    return true;
}

export function StockInboundDetailResVoFromJSON(json: any): StockInboundDetailResVo {
    return StockInboundDetailResVoFromJSONTyped(json, false);
}

export function StockInboundDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockInboundDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'batchCode': json['batchCode'] == null ? undefined : json['batchCode'],
        'sourceOrderCode': json['sourceOrderCode'] == null ? undefined : json['sourceOrderCode'],
        'inOutBizType': json['inOutBizType'] == null ? undefined : json['inOutBizType'],
        'inOutBizTypeName': json['inOutBizTypeName'] == null ? undefined : json['inOutBizTypeName'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'inboundDate': json['inboundDate'] == null ? undefined : json['inboundDate'],
        'skuNumber': json['skuNumber'] == null ? undefined : json['skuNumber'],
        'skuCost': json['skuCost'] == null ? undefined : json['skuCost'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'packageSpecification': json['packageSpecification'] == null ? undefined : json['packageSpecification'],
        'singleCbm': json['singleCbm'] == null ? undefined : json['singleCbm'],
        'totalCbm': json['totalCbm'] == null ? undefined : json['totalCbm'],
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
    };
}

export function StockInboundDetailResVoToJSON(json: any): StockInboundDetailResVo {
    return StockInboundDetailResVoToJSONTyped(json, false);
}

export function StockInboundDetailResVoToJSONTyped(value?: StockInboundDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'batchCode': value['batchCode'],
        'sourceOrderCode': value['sourceOrderCode'],
        'inOutBizType': value['inOutBizType'],
        'inOutBizTypeName': value['inOutBizTypeName'],
        'requestType': value['requestType'],
        'requestTypeName': value['requestTypeName'],
        'inboundDate': value['inboundDate'],
        'skuNumber': value['skuNumber'],
        'skuCost': value['skuCost'],
        'wtKg': value['wtKg'],
        'packageSpecification': value['packageSpecification'],
        'singleCbm': value['singleCbm'],
        'totalCbm': value['totalCbm'],
        'originPackageOutbound': value['originPackageOutbound'],
    };
}

